import { all, call, put, takeLatest } from "redux-saga/effects";
import { Types } from "../../types";
import {  deleteQueueRequest, editQueue, getActiveQueue, getQueueRequest, insertQueueRequest, uploadDefaultMusic } from "../apiRequests/queueRequest";
import {   deleteErrorAction, deleteSuccessAction, getActiveQueueErrorAction, getActiveQueueSuccessAction, getCallQueueErrorAction, getCallQueueSuccessAction, insertCallQueueErrorAction, insertCallQueueSuccessAction, updateErrorAction, updateSuccessAction, uploadDefaultMusicErrorAction, uploadDefaultMusicSuccessAction } from "../../actions/queueAction";
import { callQueueCustomerMemberForGet, defaultMusic, InsertCallQueueResponse, QueueActiveResponse, QueueResponse } from "../../types/Queues/apiRequestType";



function* insertCallQueueHandler(action: any) {
    try {
        const response: { data: InsertCallQueueResponse } = yield call(insertQueueRequest, action.payload)
        yield put(
            insertCallQueueSuccessAction({
                params: response.data
            })
        )

    } catch (error: any) {
        yield put(
            insertCallQueueErrorAction({
                error: error.message
            })
        )

    }
}

function* getQueueRequestHandler(action: any) {
    try {
        const response: { data: callQueueCustomerMemberForGet } = yield call(getQueueRequest, action.payload)

        yield put(
            getCallQueueSuccessAction({
                params: response.data
            })
        )

    } catch (error: any) {
        yield put(
            getCallQueueErrorAction({
                error: error.message
            })
        )

    }
}

function* uploadDefaultMusicRequestHandler(action: any) {
    try {
        const response: { data: boolean } = yield call(uploadDefaultMusic, action.payload)

        yield put(
            uploadDefaultMusicSuccessAction({
                params: response.data
            })
        )

    } catch (error: any) {
        yield put(
            uploadDefaultMusicErrorAction({
                error: error.message
            })
        )

    }
}

function* updateQueueRequestHandler(action: any) {
    try {
        
        const response: { data: QueueResponse } = yield call(editQueue, action.payload)

        yield put(
            updateSuccessAction({
                params: response.data
            })
        )

    } catch (error: any) {
        yield put(
            updateErrorAction({
                error: error.message
            })
        )

    }
}





function* getActiveQueueHandler(action: any) {
    try {
        const response: { data: QueueActiveResponse } = yield call(getActiveQueue, action.payload)

        yield put(
            getActiveQueueSuccessAction({
                params: response.data
            })
        )

    } catch (error: any) {
        yield put(
            getActiveQueueErrorAction({
                error: error.message
            })
        )
    }
}


function* deleteQueueRequestHandler(action: any) {
    try {
        const response: { data: boolean } = yield call(deleteQueueRequest, action.payload)

        yield put(
            deleteSuccessAction({
                params: response.data
            })
        )

    } catch (error: any) {
        yield put(
            deleteErrorAction({
                error: error.message
            })
        )
    }
}




function* queueSaga() {
    yield all([takeLatest(Types.INSERT_CALL_QUEUE_REQUEST, insertCallQueueHandler)]);
    yield all([takeLatest(Types.GET_QUEUE_REQUEST, getQueueRequestHandler)]);
    yield all([takeLatest(Types.UPLOAD_DEFAULT_MUSIC_REQUEST, uploadDefaultMusicRequestHandler)]);
    yield all([takeLatest(Types.UPDATE_QUEUE_REQUEST, updateQueueRequestHandler)]);
    yield all([takeLatest(Types.DELETE_QUEUE_REQUEST, deleteQueueRequestHandler)]);
    yield all([takeLatest(Types.GET_ACTIVE_QUEUE_REQUEST, getActiveQueueHandler)]);
  
}

export default queueSaga